(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.section-header');
			this.headerIsAlwaysSticky =
				this.getAttribute('data-sticky-type') === 'always' ||
				this.getAttribute('data-sticky-type') === 'reduce-logo-size';
			this.headerBounds = {};

			this.setHeaderHeight();

			window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

			if (this.headerIsAlwaysSticky) {
				this.header.classList.add('shopify-section-header-sticky');
			}

			this.currentScrollTop = 0;
			this.preventReveal = false;
			this.predictiveSearch = this.querySelector('predictive-search');

			// Collapse-on-scroll for the Universal Nav and Focus Nav (settings passed via data-* attributes).
			this.navCollapseEnabled = this.getAttribute('data-nav-collapse-enabled') === 'true';
			this.universalNavCollapseAt = parseInt(this.getAttribute('data-universal-nav-collapse-at'), 10);
			this.focusNavCollapseAt = parseInt(this.getAttribute('data-focus-nav-collapse-at'), 10);
			this.universalNav = document.querySelector('#universal-nav');
			this.focusSubRow = this.header.querySelector('.header-sub-row');
			this.universalNavCollapsed = false;
			this.focusNavCollapsed = false;
			this.navScrollAnchor = window.pageYOffset || document.documentElement.scrollTop;
			this.navCollapseSettleUntil = 0;
			this.navDocHeight = document.documentElement.scrollHeight;

			// The collapse animates the nav rows' height, which reflows the document. Scroll anchoring
			// would compensate by nudging scrollTop, which re-crosses the collapse threshold and causes
			// the header to oscillate (most visible on slow scroll). Opt the page scroller out of
			// anchoring, but only when the feature is on so themes that don't use it keep the default.
			if (this.navCollapseEnabled) {
				document.documentElement.style.overflowAnchor = 'none';
			}

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();
		}

		setHeaderHeight() {
			document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			this.handleNavCollapse(scrollTop);

			if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				this.header.classList.add('scrolled-past-header');
				if (this.preventHide) return;
				requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				this.header.classList.add('scrolled-past-header');
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this));
				} else {
					window.clearTimeout(this.isScrolling);

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false;
					}, 66);

					requestAnimationFrame(this.hide.bind(this));
				}
			} else if (scrollTop <= this.headerBounds.top) {
				this.header.classList.remove('scrolled-past-header');
				requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
			this.closeSearchModal();
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		}

		// Independently collapse/expand the Universal Nav and Focus Nav.
		// Per spec: each nav COLLAPSES when scrolling DOWN past its own px depth, and REVEALS on any
		// UPWARD scroll (direction-based, not depth-gated). A NaN depth (empty setting) opts that nav out.
		//
		// Direction is measured against an anchor that only moves when we act, with a deadzone in
		// between. Collapsing/revealing changes the header height, which changes document height; near
		// the top or bottom of the page the browser nudges scrollTop a few px to keep it in range, and
		// a per-event check would read those nudges as direction changes and flip the state repeatedly.
		// The deadzone absorbs that jitter while still responding to real scrolling.
		//
		// The deadzone alone isn't enough at the very bottom: a toggle changes document height by the
		// rows' combined height (~67px), and near the page boundary the browser answers that with an
		// involuntary scrollTop shift of the same magnitude (a clamp on collapse, scroll-anchoring on
		// expand — overflow-anchor doesn't suppress the latter here). That shift dwarfs the 10px deadzone
		// and reads as a reversal, flipping the state straight back — the footer "dance" on a slow scroll
		// up. So after each toggle we hold a settle window (a touch longer than the 0.28s height
		// transition) during which we keep following the scroll position but don't toggle, letting the
		// self-induced movement pass without being mistaken for the user changing direction.
		//
		// Finally, iOS Safari reports scrollTop past the page bounds while the rubber-band overscroll
		// bounces at the top/bottom; clamping to the valid range keeps that rebound from registering as a
		// real upward scroll and flashing a nav in and out as the page settles. (No-op on desktop, which
		// never overscrolls.)
		handleNavCollapse(scrollTop) {
			if (!this.navCollapseEnabled) return;

			const scrollHeight = document.documentElement.scrollHeight;
			const maxScroll = scrollHeight - window.innerHeight;
			scrollTop = Math.max(0, Math.min(scrollTop, maxScroll));

			// At the very top of the page the navs must always be shown. A quick scroll up can return to
			// the top entirely within the post-toggle settle window (or in steps below the deadzone), so
			// the upward events that would reveal the navs get swallowed — and because the page can't
			// scroll past 0, no further events fire to correct it and a nav stays stuck collapsed. Force
			// them open here, ahead of the deadzone and settle checks, so reaching the top always restores
			// them. (Expanding at scrollTop 0 grows the document downward with the viewport pinned, so it
			// can't cause the boundary recoil the settle window guards against.)
			if (scrollTop <= 0) {
				if (this.universalNav && this.universalNavCollapsed) {
					this.universalNavCollapsed = false;
					this.setNavCollapsed(this.universalNav, false);
				}
				if (this.focusSubRow && this.focusNavCollapsed) {
					this.focusNavCollapsed = false;
					this.setNavCollapsed(this.focusSubRow, false);
				}
				this.navScrollAnchor = scrollTop;
				return;
			}

			const delta = scrollTop - this.navScrollAnchor;
			if (Math.abs(delta) < 10) return; // deadzone: ignore movement smaller than this
			this.navScrollAnchor = scrollTop;

			// Layout shifts during load — CLS from images/ads, and the staged scroll restoration that drags
			// scrollTop toward a deep saved position as the document grows — move scrollTop without a scroll
			// gesture, in steps small enough to slip past the jump check below. A real gesture happens over a
			// stable document, so when the height changes we re-baseline and hold the settle window: that
			// suppresses both this event and the stable-height follow-ups that land before the layout quiets
			// (350ms after the last change), which a bare re-baseline would miss. Real scrolling resumes once
			// the document has been still. (Our own collapse resizes the document too and lands here harmlessly.)
			if (scrollHeight !== this.navDocHeight) {
				this.navDocHeight = scrollHeight;
				this.navCollapseSettleUntil = performance.now() + 350;
				return;
			}

			// A single event this large isn't a scroll gesture — it's a jump (End/Home, an in-page anchor, or
			// a one-shot scroll restoration). Re-baseline to it but don't collapse or reveal: the navs react
			// only to real scrolling, so a page reloaded at depth comes up with them shown and the first
			// genuine scroll down past a depth is what collapses them.
			if (Math.abs(delta) > 200) return;

			// Settle window: ignore movement (including our own height-change recoil) right after a toggle.
			if (this.navCollapseSettleUntil && performance.now() < this.navCollapseSettleUntil) return;

			const scrollingDown = delta > 0;
			let toggled = false;

			if (this.universalNav && !isNaN(this.universalNavCollapseAt)) {
				if (scrollingDown) {
					if (!this.universalNavCollapsed && scrollTop > this.universalNavCollapseAt) {
						this.universalNavCollapsed = true;
						this.setNavCollapsed(this.universalNav, true);
						toggled = true;
					}
				} else if (this.universalNavCollapsed) {
					this.universalNavCollapsed = false;
					this.setNavCollapsed(this.universalNav, false);
					toggled = true;
				}
			}

			if (this.focusSubRow && !isNaN(this.focusNavCollapseAt)) {
				if (scrollingDown) {
					if (!this.focusNavCollapsed && scrollTop > this.focusNavCollapseAt) {
						this.focusNavCollapsed = true;
						this.setNavCollapsed(this.focusSubRow, true);
						toggled = true;
					}
				} else if (this.focusNavCollapsed) {
					this.focusNavCollapsed = false;
					this.setNavCollapsed(this.focusSubRow, false);
					toggled = true;
				}
			}

			// 350ms > the 0.28s max-height transition, so the document has finished resizing — and any
			// boundary recoil it caused has fired — before we resume reading scroll direction.
			if (toggled) this.navCollapseSettleUntil = performance.now() + 350;
		}

		// Animate a nav row open/closed via max-height. The full height is measured with offsetHeight
		// while the row is still open (on collapse) and cached on the element, so the re-expand animates
		// to the correct height instead of a value measured mid-transition. Any pending "clear to auto"
		// handler is removed first so a collapse interrupting an in-flight expand can't pop the row open.
		setNavCollapsed(el, collapsed) {
			if (el._navClearHandler) {
				el.removeEventListener('transitionend', el._navClearHandler);
				el._navClearHandler = null;
			}

			if (collapsed) {
				el._navFullHeight = el.offsetHeight; // measured while open = the true height incl. padding
				el.style.maxHeight = el._navFullHeight + 'px';
				el.getBoundingClientRect(); // force reflow so the transition has a starting height
				el.classList.add('cusa-nav-collapsed');
				el.style.maxHeight = '0px';
			} else {
				const fullHeight = el._navFullHeight || el.scrollHeight;
				el.style.maxHeight = '0px';
				el.getBoundingClientRect();
				el.classList.remove('cusa-nav-collapsed');
				el.style.maxHeight = fullHeight + 'px';
				el._navClearHandler = (event) => {
					if (event.target !== el || event.propertyName !== 'max-height') return;
					el.style.maxHeight = ''; // hand height back to layout once fully open
					el.removeEventListener('transitionend', el._navClearHandler);
					el._navClearHandler = null;
				};
				el.addEventListener('transitionend', el._navClearHandler);
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
			this.disclosures.forEach((disclosure) => disclosure.close());
		}

		closeSearchModal() {
			this.searchModal = this.searchModal || this.header.querySelector('details-modal');
			this.searchModal.close(false);
		}
	}

	customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
